export var JoyLoggingServiceDataKey;
(function (JoyLoggingServiceDataKey) {
    JoyLoggingServiceDataKey["category"] = "category";
    JoyLoggingServiceDataKey["parameters"] = "parameters";
})(JoyLoggingServiceDataKey || (JoyLoggingServiceDataKey = {}));
export var JoyLoggingServiceMessageCategory;
(function (JoyLoggingServiceMessageCategory) {
    JoyLoggingServiceMessageCategory["info"] = "info";
    JoyLoggingServiceMessageCategory["warning"] = "warning";
    JoyLoggingServiceMessageCategory["error"] = "error";
})(JoyLoggingServiceMessageCategory || (JoyLoggingServiceMessageCategory = {}));
export default class JoyLoggingService {
    static add(destination) {
        this.destinations.push(destination);
    }
    static setUserId(userId) {
        this.destinations.forEach((destination) => {
            destination.setUserId(userId);
        });
    }
    static log(category, parameters) {
        let data = new Map();
        data[JoyLoggingServiceDataKey.category] = category;
        data[JoyLoggingServiceDataKey.parameters] = parameters;
        this.destinations.forEach((destination) => {
            destination.log(data);
        });
    }
    static reset() {
        this.destinations.forEach((destination) => {
            destination.reset();
        });
    }
}
JoyLoggingService.destinations = [];
//# sourceMappingURL=JoyLoggingService.js.map